import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { mobile, mobileM, tablet, laptopM } from "../../responsive";
import FurnitureThreeScene from "./FurnitureThreeScene";

//
//
const HomeWrapper = styled.div`
  padding: 0 0 30px 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${mobile({
    backgroundColor: "rgb(243, 243, 243)",
  })}
`;
const ThreeScene = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  /* width: 90%; */
  width: 100%;
  height: 100%;
  text-align: center;
  max-width: 1150px;
  overflow: hidden;
  ${mobile({
    width: "75%",
    height: "40%",
  })}
  ${mobileM({
    width: "80%",
    maxWidth: "900px",
  })}
    ${tablet({
    width: "80%",
    maxWidth: "1000px",
  })}
`;

const H1 = styled.h1`
  padding: 70px 0 0 0;
  font-weight: 600;
  font-size: 1.6em;
  font-family: "Poppins-Light";
  text-transform: Capitalize;
  letter-spacing: 3px;
  text-align: center;
  color: #272727f8;
`;
const H2 = styled.h1`
  padding: 0 0 40px 0;
  line-height: 20px;
  font-weight: 600;
  font-size: 0.9em;
  font-family: "Poppins-Light";
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;

  color: #272727e6;
  ${mobile({
    padding: "0 0 40px 0",
    lineHeight: "calc(9px + 1.4vmin)",
    fontSize: "calc(9px + 1.4vmin)",
    color: "#272727e6",
    fontWeight: "600",
  })}
`;

//
//
//

const Furniture = () => {
  return (
    <>
      {/*  */}
      <HomeWrapper>
        <H1>Bestsellers</H1>
        <H2>VIEW ALL</H2>
        <ThreeScene>
          <FurnitureThreeScene />
        </ThreeScene>
      </HomeWrapper>
    </>
  );
};

export default Furniture;
